<template>
  <div class="background">
    <div class="main">
      <i class="iconfont iconx" @click="close"></i>
      <div class="title">
        订单支付
      </div>
      <div class="detail">
        <!-- <p>
          <span>订单编号：</span>
          <span>{{orderId}}</span>
        </p> -->
        <p>
          <span>订单名称：</span>
          <span>导师辅导【{{version}}】</span>
        </p>
        <!-- <p>
          <span>下单时间：</span>
          <span>{{moment(new Date()).format("YYYY-MM-DD")}}</span>
        </p> -->
        <p>
          <span>服务条件：</span>
          <span>{{additional}}</span>
        </p>
      </div>
      <div v-if="interviewCoachingData && displayInterviewCoachBlock" class="welfare-content">
        <div class="welfare-label-content">限时福利</div>
        <div class="welfare-desc-content">
          <div class="title-content">
            <div class="welfare-title">{{ interviewCoachingData.title }}</div>
            <div class="welfare-detail">
              详情
              <p class="service-item-tips">{{ interviewCoachingData.descTips }}</p>
            </div>
          </div>
          <div class="title-desc">{{ interviewCoachingData.dialogDesc }}
            <span>（随时可用，未用随时可退）</span>
          </div>
        </div>
        <div class="welfare-check-content">
          <div class="price-intro">
            <div class="real-price">
              <span class="rmb-symbol">¥</span>
              <span class="number">
                {{(orderPriceData.recommand_price - orderPriceData.total_price) / 100}}
              </span>
            </div>
            <div class="original">
              ¥{{(orderPriceData.recommand_origin_price - orderPriceData.origin_total_price) / 100}}
            </div>
          </div>
          <el-checkbox :value="hasCoach" @change="handleUpdateCoach"></el-checkbox>
        </div>
      </div>
      <div class="content">
        <div class="pay">
          <div class="Qrcode">
            <qrcode-vue :value="`${host}/pay/type?type=mentor&orderId=${orderId}`" :size="126"
                        class="Qrcode-component"/>
            <div class="qrcode-not" v-show="finallyOrderPrice==0">
              <p>无需扫码</p>
              <p>点击「立即购买」</p>
            </div>
          </div>
          <div class="pay-content">
            <p><span class="pic-num">￥{{finallyOrderPrice}}</span>
            </p>
            <p>
              <img src="https://files.wondercv.com//web/member/alipay.png">
              <img src="https://files.wondercv.com//web/member/wechat.png">
            </p>
            <p>使用支付宝/微信，扫码支付</p>
          </div>
          <div class="pay-success-btn" v-show="isShowBtn">
            <div class="btn" @click="handleClickCheck" v-if="finallyOrderPrice">
              支付成功
            </div>
            <div class="btn" @click="handleClickPay" v-else>
              立即购买
            </div>
            <div class="text" v-show="isShowError">遇到问题? 请咨询右下角客服</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from "vuex"
  import moment from "moment"
  import qrcodeVue from 'qrcode-vue';
  import api from "../../../api";
  import {routerTo} from "../../../assets/js/util";

  export default {
    name: "payAlert",
    props: {
      detail: {
        type: Object,
        default: () => {}
      },
      money: {
        type: Number
      },
      orderId: {
        type: String
      },
      currentServiceData: {
        type: Array,
        default: () => []
      },
      orderReq: {
        type: Object,
        default: () => {}
      },
      orderPriceData: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        moment,
        host: "",
        isError: false,
        isShowBtn: false,
        isPayLoading: false,
        timer: null,
        isShowError:false,
        hasCoach: false
      }
    },
    computed: {
      ...mapState("me", ["personInfo"]),
      additional() {
        let str = ""
        console.log('detail============>', this.detail)
        Object.keys(this.detail).forEach(key => {
          if (this.detail[key]) {
            if (key != 'change_profession') {
              str += `【${this.detail[key]}】 `
            } else {
              let plan = this.$route.query.plan
              if (plan === 'full') {
                str += `【转行】 `
              } else if (plan === 'intern') {
                str += `【零经验】 `
              } else if (plan === 'campus') {
                str += `【非本专业求职】 `
              }
            }
          }
        })
        return str
      },
      version() {
        let {plan} = this.$route.query
        return plan === 'intern' ? '实习版' : (plan === 'full' ? '在职版' : '校招版')
      },
      interviewCoachingData() {
        return this.currentServiceData.find(item => item.type === 'interview_guidance')
      },
      displayInterviewCoachBlock() {
        const { price_params } = this.orderReq
        if (price_params?.basic_service?.length === 1) {
          return price_params.basic_service[0] === 'cv_optimize';
        }
      },
      finallyOrderPrice() {
        if (!this.displayInterviewCoachBlock) return this.money;
        return (this.hasCoach ? this.orderPriceData.recommand_price : this.orderPriceData.total_price) / 100
      }
    },
    components: {
      qrcodeVue
    },
    created() {
      // this.host = 'https://m.wondercv.cn'
      this.host = window.location.origin.replace("www", "m")
      setTimeout(() => {
        this.isShowBtn = true
      }, 3000)
    },
    async mounted() {
      document.body.style.overflow = 'hidden'
      this.timer = setInterval(() => {
        this.checkOrder();
      }, 3000)
    },
    methods: {
      async handleUpdateCoach(value) {
        const isUpdate = await this.updateMentorOrder(value);
        if (isUpdate) {
          this.hasCoach = value;
        }
      },
      async updateMentorOrder(value) {
        if (!this.displayInterviewCoachBlock) return console.log('没有限时福利')
        const req = JSON.parse(JSON.stringify(this.orderReq || {}))
        req.interview_guidance = value;
        if (req?.price_params) {
          if (value) {
            req.price_params.basic_service.push('interview_guidance')
          } else {
            req.price_params.basic_service = ['cv_optimize']
          }
          try {
            const res = await api.mentorOrders.updateMentorOrder(this.orderId, req);
            if (res.code === 600205) {
              this.$message.error(res.message)
            }
            return res.code === 1000;
          } catch (error) {
            console.log(error)
          }
        }
      },
      close() {
        document.body.style.overflow = 'visible'
        this.$emit("close")
      },
      async handleClickCheck() {
        if (this.isError) {
          return
        }
        this.isError = true
        let res = await api.account.checkOrder(this.orderId, {order_type: "mentor"})
        if (res.code == 1000) {
          let {status} = res.data
          if (status == 'paid') {
            this.$message.success("支付成功")
            this.isError = false
            setTimeout(() => {
              routerTo(`/service/pay_success/${this.orderId}`)
            }, 500)
          } else {
            this.$message.error("订单支付失败，请继续支付")
            this.isError = false
            this.isShowError = true
          }
        } else {
          this.$message.error(res.message)
        }
      },
      async handleClickPay() {
        if (this.isPayLoading) return
        this.isPayLoading = true
        let res = await api.mentorOrders.orderPay(this.orderId)
        if (res.code === 1000) {
          this.$message.success("支付成功")
          setTimeout(() => {
            routerTo(`/service/pay_success/${this.orderId}`)
          }, 300)
          this.close()
        }
        this.isPayLoading = false
      },
      //轮训检查订单
      async checkOrder() {
        let res = await api.account.checkOrder(this.orderId, {order_type: "mentor"})
        if (res.code == 1000) {
          let {status} = res.data
          if (status == 'paid') {
            this.$message.success("支付成功")
            clearInterval( this.timer)
            setTimeout(() => {
              routerTo(`/service/pay_success/${this.orderId}`)
            }, 500)
          }
        }
      }
    },
    beforeDestroy() {
      clearInterval( this.timer)
    }
  }
</script>

<style scoped lang="scss">
  .background {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }

  .main {
    width: 700px;
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    border-radius: 8px;
    background: #fff;

    .title {
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(64, 64, 64, 1);
      line-height: 24px;
      text-align: center;
      margin-top: 38px;
      margin-bottom: 40px;
    }

    .iconx {
      position: absolute;
      font-size: 24px;
      color: rgba(255, 255, 255, 1);
      opacity: 0.7;
      top: 43px;
      right: 32px;
      cursor: pointer;
      z-index: 999;
      color: #000;
    }

    .detail {
      width: 636px;
      // height: 194px;
      background: rgba(249, 249, 249, 1);
      border-radius: 8px;
      margin: 0 auto;
      padding: 24px;
      box-sizing: border-box;
      > p {
        display: flex;
        margin-bottom: 20px;

        &:last-of-type {
          margin-bottom: 0;
        }

        & > span:first-child {
          width: 70px;
          height: 14px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(156, 156, 156, 1);
          line-height: 24px;
          margin-right: 12px;
        }

        & > span:last-child {
          width: 473px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(64, 64, 64, 1);
          line-height: 24px;
        }
      }
    }

    .welfare-content {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 18px 32px -6px;
      padding: 24px;
      border: 1px solid #F5F6FA;
      border-radius: 8px;
      .welfare-label-content {
        position: absolute;
        top: -9px;
        left: 0;
        border-radius: 10px 0 10px 0;
        padding: 5px 10px;
        background: linear-gradient(to right, #FF9F79, #FF6644);
        color: #fff;
      }
      .welfare-desc-content {
        display: flex;
        flex-direction: column;
        .title-content {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          .welfare-title {
            margin-right: 8px;
            font-size: 16px;
            color: #404040;
            font-weight: 500;
          }
          .welfare-detail {
            position: relative;
            width: 48px;
            height: 22px;
            line-height: 22px;
            background: #F9F9F9;
            border-radius: 11px;
            box-sizing: border-box;
            font-size: 14px;
            font-weight: 400;
            color: #BCBCBC;
            text-align: center;
            cursor: pointer;

            &:hover {
              color: #ffffff;
              background: #505667;

              .service-item-tips {
                display: block;
              }

            }

            .service-item-tips {
              display: none;
              position: absolute;
              top: -80px;
              left: -20px;
              width: 348px;
              padding: 12px;
              background: #505667;
              border-radius: 4px;
              box-sizing: border-box;
              color: #ffffff;
              text-align: left;

              &::after {
                content: "";
                position: absolute;
                left: 40px;
                bottom: -10px;
                width: 0;
                height: 0;
                border-top: 10px solid #505667;
                border-left: 6px solid transparent;
                border-right: 6px solid transparent;
              }
            }
          }
        }
        .title-desc {
          font-size: 12px;
          color: #404040;
          span {
            color: #9C9C9C;
          }
        }
      }
      .welfare-check-content {
        display: flex;
        align-items: center;
        .price-intro {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-right: 24px;
          .real-price {
            font-size: 24px;
            color: #404040;
            font-weight: 600;
            margin-bottom: 4px;
            .rmb-symbol {
              font-size: 14px;
            }
          }
          .original {
            width: 44px;
            text-align: center;
            font-size: 16px;
            color: rgba($color: #404040, $alpha: .6);
            text-decoration: line-through;
          }
        }
        .el-checkbox {
          // margin-right: 16px;
          ::v-deep .el-checkbox__inner {
            width: 26px;
            height: 26px;
            border-color: #9C9C9C;
            &::after {
              width: 6px;
              height: 13px;
              left: 9px;
              top: 3px;
            }
          }
        }
        .is-checked {
          ::v-deep .el-checkbox__inner {
            background-color: #FF6644;
            border-color: #FF6644;
          }
        }
      }
    }

    .content {
      padding: 24px 32px;

      .pay {
        width: 637px;
        height: 174px;
        border-radius: 8px;
        margin-bottom: 4px;
        box-sizing: border-box;
        border: 1px solid rgba(245, 246, 250, 1);
        padding: 24px;
        display: flex;

        .Qrcode {
          width: 95px;
          height: 96px;
          margin-right: 18px;
          position: relative;
          top: 10px;

          .Qrcode-component {
            width: 95px;
            height: 96px;

            img {
              width: 95px;
              height: 96px;
            }

            /deep/ img {
              width: 95px;
              height: 96px;
            }
          }

          .qrcode-not {
            position: absolute;
            top: 0;
            left: 0;
            width: 95px;
            height: 96px;
            background-color: rgba(255, 255, 255, 0.93);
            text-align: center;
            font-size: 14px;
            font-weight: 400;
            color: rgba(64, 64, 64, 1);
            line-height: 24px;
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
        }

        .pay-content {
          display: flex;
          flex-direction: column;
          justify-content: center;

          & > p {
            display: flex;
            margin-bottom: 10px;
            color: #404040;
            font-size: 14px;
            align-items: flex-end;
            // margin-top: 15px;

            .pic-num {
              font-size: 28px;
              font-weight: 600;
              color: rgba(255, 102, 68, 1);
            }

            .preferential-pic {
              font-size: 16px;
              font-weight: 400;
              color: #FF6644;
            }

            & > img {
              width: 24px;
              height: 24px;
              margin-right: 16px;
            }
          }
          & > p:nth-child(3){
            margin-top: 5px;
          }
        }

        .pay-success-btn {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-end;

          .btn {
            margin-top: 11px;
            width: 104px;
            height: 36px;
            border-radius: 18px;
            background: linear-gradient(180deg, rgba(255, 159, 121, 1) 0%, rgba(255, 102, 68, 1) 100%);
            margin-bottom: 20px;
            text-align: center;
            line-height: 36px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            font-size: 14px;
            cursor: pointer;
            margin-right: 19px;
          }

          .text {
            width: 170px;
            height: 14px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 102, 68, 1);
            line-height: 14px;
            white-space: nowrap;
          }
        }
      }


    }
  }


</style>